var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5.66759V6.18538C18 7.18008 17.1961 7.98402 16.2014 7.98402H1.79864C0.803936 7.98402 0 7.18008 0 6.18538V5.66759C0 4.67289 0.803936 3.86896 1.79864 3.86896H16.2014C17.1961 3.86896 18 4.67289 18 5.66759Z",
    fill: "#858D9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10132 4.63199V3.61003C4.10132 2.8606 4.40109 2.13842 4.93251 1.60701C5.46392 1.07559 6.1861 0.775818 6.93553 0.775818H11.0506C11.8 0.775818 12.5222 1.07559 13.0536 1.60701C13.585 2.13842 13.8848 2.8606 13.8848 3.61003V4.63199C13.8848 5.35417 13.1081 5.4223 13.1081 5.4223C12.8356 5.4223 12.604 5.28604 12.4677 5.08165C12.4132 4.99989 12.3723 4.90451 12.3451 4.78187C12.3451 4.741 12.3314 4.70012 12.3314 4.65924V4.64561V3.61003C12.3314 3.26938 12.1952 2.94236 11.9499 2.69709C11.7183 2.46545 11.3912 2.32919 11.0506 2.32919H6.93553C6.59488 2.32919 6.26786 2.46545 6.02259 2.71072C5.79095 2.94236 5.65469 3.26938 5.65469 3.61003V4.63199C5.65469 5.35417 4.878 5.4223 4.878 5.4223C4.45559 5.40867 4.10132 5.06802 4.10132 4.63199Z",
    fill: "#858D9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8553 8.93781L16.0786 20.261C15.9696 21.7463 14.7433 22.8909 13.258 22.8909H4.74176C3.25652 22.8909 2.01655 21.7463 1.92117 20.261L1.13086 8.93781C1.34888 8.97868 1.56689 9.00594 1.79853 9.00594H16.2013C16.4193 9.00594 16.6373 8.97868 16.8553 8.93781ZM8.2164 11.8402V19.5525C8.2164 19.9749 8.55705 20.3292 8.99308 20.3292C9.42912 20.3292 9.76977 19.9885 9.76977 19.5525V11.8402C9.76977 11.4177 9.42912 11.0635 8.99308 11.0635C8.55705 11.0635 8.2164 11.4177 8.2164 11.8402ZM11.8273 11.7856L11.3095 19.498C11.2823 19.9204 11.6093 20.2883 12.0317 20.3155C12.4541 20.3428 12.822 20.0158 12.8493 19.5934L13.367 11.881C13.3943 11.4586 13.0673 11.0907 12.6449 11.0635C12.2225 11.0362 11.8546 11.3632 11.8273 11.7856ZM4.61913 11.8947L5.13691 19.607C5.16417 20.0294 5.53207 20.3564 5.95448 20.3292C6.37688 20.3019 6.70391 19.934 6.67666 19.5116L6.15887 11.7993C6.13162 11.3769 5.76371 11.0498 5.3413 11.0771C4.9189 11.1043 4.59187 11.4722 4.61913 11.8947Z",
    fill: "#858D9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3c78687b832d9aa65eef334adb6fa670.svg";
export { ForwardRef as ReactComponent };